/**
 * NapsTable component.
 * consists of Helmet, that contains met information
 * and Table with data
 */
/**
 * Import third-party modules
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from './NapsTableHeader';
import Body from './NapsTableBody';
import meta from './meta.json';
import PricesWrapper from '../PricesWrapper';

/**
 * Stateless NapsTable component.
 * Utilizes Helmet component to render meta information relative to this page.
 * @param data
 * @param loading
 * @param sortedBy
 * @param onSort
 * @constructor
 */
const NapsTable = ({
    data,
    loading,
    sortedBy,
    onSort,
}) => (
    <div>
        <Helmet {...meta} />
        <div className="tn-napsTable ui-table ui-table_sortable">
            <Header
                sortedBy={sortedBy}
                onSort={onSort}
            />
            <PricesWrapper
                priceLocation="Naps Table"
            >
                <Body
                    data={data}
                    loading={loading}
                />
            </PricesWrapper>
        </div>
    </div>
);

/**
 * Prop types validation
 * @type {{data: *, loading: *, sortedBy: *, onSort: *}}
 */
NapsTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        horseName: PropTypes.string,
        horseId: PropTypes.number,
        time: PropTypes.string,
        course: PropTypes.string,
        tipster: PropTypes.string,
        levelStake: PropTypes.number
    })).isRequired,
    loading: PropTypes.bool.isRequired,
    sortedBy: PropTypes.string.isRequired,
    onSort: PropTypes.func.isRequired,
};

export default NapsTable;



// WEBPACK FOOTER //
// ./src/js/napsTable/NapsTable.js